const { getCookie } = require('./helpers');
const { orderBy, keys } = require('lodash');

const utils = (storeUtils = window.flex) => {

    const { getStore } = storeUtils;

    function getConfigCodes(...kinds) {
        const store = getStore();
        if (!store || !store.configCodes || !kinds.every(key => key in store.configCodes)) {
            return [];
        }

        const allCodes = kinds.reduce((acc, kind) => {
            const codes = keys(store.configCodes[kind]).map(key => ({
                code: store.configCodes[kind][key],
                summary: key
            }));

            acc.push(...codes);

            return acc;
        }, []);

        return orderBy(allCodes, 'code');
    }

    function getConfigCodeObject(codeKind) {
        const store = getStore();
        if (!store || !store.configCodes || !store.configCodes[codeKind]) {
            return {};
        }

        return store.configCodes[codeKind];
    }

    function simpleCode(code) {
        return !code ? '' : code.substring(code.lastIndexOf('-') + 1).toUpperCase();
    }

    function formatString(string, ...args) {
        if (!string) {
            return '';
        }

        return string.replace(/{(\d+)}/g, (match, number) => (typeof args[number] !== 'undefined' ? args[number] : match));
    }

    function text(key, defaultValue, module) {
        const store = getStore();

        if(typeof(module) !== "string"){
            module = "";
        }
        const localText =  store.localText || store.appContext.localtext;
        if (!localText || !key || !localText[module]) {
            return defaultValue;
        }
        const moduleText = localText[module]

        key = key.toUpperCase();
        if (moduleText[key] === "") {
            return defaultValue;
        }
        if(getCookie("flex-show-local") == "1"){
            var localTextUrl = store.appContext.localTextPath;
            //Extract the org from the local text
            var orgRegex = new RegExp('(?=Org).*(?=\\?)');
            var org = orgRegex.exec(localTextUrl);
            return (key || "no key") + " : " + getCookie("flex-locale") + " : " + org + " : " + (moduleText[key] || defaultValue || key);
        }
        return moduleText[key] || defaultValue || key;
    }

    return {
        getConfigCodes,
        getConfigCodeObject,
        simpleCode,
        text,
        formatString
    };
}

module.exports = utils;